import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // Listen for the custom event from the bathing status controller
    document.addEventListener("bathing-status-changed", this.handleStatusChange.bind(this))
    
    // Initial check - try to find the current status
    const statusRadio = document.querySelector('input[name="service[bathing_status]"]:checked')
    if (statusRadio) {
      const status = statusRadio.value
      this.toggleVisibility(status === "open" || status === "risky")
    }
  }
  
  disconnect() {
    // Clean up event listener
    document.removeEventListener("bathing-status-changed", this.handleStatusChange.bind(this))
  }
  
  handleStatusChange(event) {
    this.toggleVisibility(event.detail.showTemperature)
    
    // If hiding, clear the input value
    if (!event.detail.showTemperature) {
      const input = this.element.querySelector('input[type="number"]')
      if (input) {
        input.value = ""
      }
    }
  }
  
  toggleVisibility(show) {
    if (show) {
      this.element.classList.remove("d-none")
    } else {
      this.element.classList.add("d-none")
    }
  }
} 